import { ResourcePayload } from '_api/types';

const DefaultNewResource: ResourcePayload = {
  title: '',
  description: '',
  imageUrl: '',
  url: '',
  documentUrl: '',
  shareWithOrg: false,
};

export default DefaultNewResource;
